import { code as statuses } from 'statuses';

class AppAuthInterception {
  constructor($location, $q, appEvents, APP_EVENTS) {
    'ngInject';

    this.$location = $location;
    this.$q = $q;
    this.appEvents = appEvents;
    this.APP_EVENTS = APP_EVENTS;

    this.responseError = this.responseError.bind(this);
  }
  responseError(response) {
    if (
      !this.$location.path().includes('login') &&
      response.status === statuses.unauthorized
    ) {
      this.appEvents.emit(this.APP_EVENTS.session.unauthorized);
    }

    return this.$q.reject(response);
  }
}

export default AppAuthInterception;
